import { NEIGHBARS_ASSETS } from '../constants'

const Hero = () => {
  return (
    <section className="neighbars__hero">
      <picture>
        <source
          media="(min-width: 768px)"
          srcSet={`${NEIGHBARS_ASSETS}/desktop/neighbars-hero_imagen-desktop1280px.webp`}
        />
        <img
          className="neighbars__hero-media"
          src={`${NEIGHBARS_ASSETS}/neighbars-hero_imagen-mobile.webp`}
          alt=""
          aria-hidden="true"
        />
      </picture>
    </section>
  )
}

export default Hero
